module.exports = __webpack_public_path__ + "static/img/about_map.91e85f6c.png";